<script setup>
import { Banner } from '@dashhudson/dashing-ui/banner';
import { computed } from 'vue';

import { useSocialListeningTopicsStore } from '@/stores/social-listening-topics';

const topicsStore = useSocialListeningTopicsStore();

const showBanner = computed(
  () => topicsStore.hasRestrictedContent && !topicsStore.restrictedContentBannerDismissed,
);

const message = computed(() => {
  const count = topicsStore.restrictedContentCount.toLocaleString();
  return `${count} mentions related to this Topic aren't displayed because you can only view comments and UGC from brands you have access to. Contact your administrator to update your brand permissions.`;
});

function handleClose() {
  topicsStore.restrictedContentBannerDismissed = true;
}
</script>

<template>
  <Banner v-if="showBanner" severity="warn" :message="message" closable @close="handleClose" />
</template>
